import idx from 'idx'
import { withFormik } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'

import { isEqual } from 'utils/misc'
import { required } from 'utils/validation'

import { 
  FORM_SUBMIT_STATUS,
  FORM_PROGRESS_STATUS,
  FORM_ACTION_ERROR_STATUS,
} from 'constants/form'

import * as groupModule from 'modules/group'
import * as popoverModule from 'modules/popover'

export default compose(
  connect(
    (state) => {
      return {
        organisation: idx(state, _ => _.organisation.selected)
      }
    },
    (dispatch) => {
      const actions = {
        ...groupModule,
        ...popoverModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withFormik({
    mapPropsToValues: ({ data }) => ({ name: data.name }),
    validate: ({ name }) => {
      const errors = {}

      if (required(name)) {
        errors.name = 'Please enter a valid group name'
      }

      return errors
    },
    enableReinitialize: true,
    validateOnChange: false,
    handleSubmit: (values, {
      props, setSubmitting,
    }) => {
      setSubmitting(true)
      const initialValues = { name: props.data.name }

      if (!isEqual(values, initialValues)) {
        props.actions.updateGroup(props.organisation, props.data, values)
        props.handleClose()
      } else {
        props.handleClose()
      }
    },
  }),
  withHandlers({
    handleFieldChange: props => (event) => {
      props.setStatus(FORM_PROGRESS_STATUS)
      props.handleChange(event)
    },
    handleFormSubmit: props => (event) => {
      props.setStatus(FORM_SUBMIT_STATUS)
      props.handleSubmit(event)
    },
    handleGroupDeleteClick: props => () => {
      props.actions.showPopover(popoverModule.DELETE_GROUP_CONFIRM, props.data)
    },
    hasFieldError: props => (fieldName) => {
      return !!((props.errors[fieldName] && props.errors[fieldName].length && props.status === FORM_SUBMIT_STATUS))
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        apiCallError, setStatus, setSubmitting
      } = this.props
      // trigger when error occured during login
      if (prevProps.apiCallError !== apiCallError && apiCallError) {
        setStatus(FORM_ACTION_ERROR_STATUS)
        setSubmitting(false)
      }
    },
  })
)




// WEBPACK FOOTER //
// ./src/components/organisms/EditGroupForm/EditGroupForm.enhancer.js